import { useTranslation } from '@msdk/common'
import { styled, uiTokens } from '@msdk/ui'
import { useWizard } from 'react-use-wizard'

import { FooterPopup } from './FooterPopup'
import { GeneratedCodeField } from './GeneratedCodeField'
import { HeaderPopup } from './HeaderPopup'
import {
  ModalStepProps,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledEditContent,
  StyledMessageTypography,
  StyledSummaryTypography,
} from './shared'

const StyledListItem = styled('li')`
  padding: ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.xSmall}px;
  gap: ${uiTokens.spacing.gap.small}px;
  color: ${uiTokens.uiContent.emphasized};
  font-family: ${uiTokens.font.fontFamily.default};
  font-size: ${uiTokens.font.fontSize.uiControlText.medium}px;
  font-style: normal;
  font-weight: ${uiTokens.font.fontWeight.medium};
  line-height: ${uiTokens.font.lineHeight.uiControlText.medium}px;
  letter-spacing: ${uiTokens.font.letterSpacing.normal}px;
`

const StyledList = styled('ol')`
  padding: ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.medium}px ${uiTokens.spacing.padding.medium}px
    ${uiTokens.spacing.padding.medium}px;
`

export function FaceGeneratedCodePopup(props: ModalStepProps) {
  const { goToStep } = useWizard()
  const t = useTranslation()

  return (
    <>
      <HeaderPopup title={t('LBL_NGID_FACE_RECO_TITLE', 'Face recognition')} modalRef={props.modalRef} />
      <StyledEditContent>
        <StyledMessageTypography variant="body1">
          {t(
            'LBL_NGID_FACE_RECO_CODE_DESCR',
            'Use generated activation code and finish the setup at the dialysis device.',
          )}
        </StyledMessageTypography>
        <GeneratedCodeField codeType="face" />
        <StyledAccordion>
          <StyledAccordionSummary aria-controls="panel2-content" id="panel2-header">
            <StyledSummaryTypography>
              {t('LBL_NGID_FACE_RECO_GUIDLINES_TITLE', 'Face recognition activation')}
            </StyledSummaryTypography>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            <StyledList>
              <StyledListItem>
                {t('LBL_NGID_FACE_RECO_GUIDLINES_DESCR1', `Go to dialysis device and select 'user enrollment'.`)}
              </StyledListItem>
              <StyledListItem>
                {t('LBL_NGID_FACE_RECO_GUIDLINES_DESCR2', 'Select face recognition option and enter activation code.')}
              </StyledListItem>
              <StyledListItem>
                {t(
                  'LBL_NGID_FACE_RECO_GUIDLINES_DESCR3',
                  'Follow the instructions on the device screen to complete the process.',
                )}
              </StyledListItem>
            </StyledList>
          </StyledAccordionDetails>
        </StyledAccordion>
      </StyledEditContent>
      <FooterPopup primary={{ label: t('LBL_NGID_DONE_BTN', 'Done'), onClick: () => goToStep(3) }} />
    </>
  )
}
